'use client'

import dynamic from 'next/dynamic'

import { RenderOnScroll } from '@/components/RenderOnScroll'

import type { SEOCollapseProps } from './SeoCollapse'

const DynamicSeoCollapse = dynamic(() =>
	import('./SeoCollapse').then((mod) => mod.SEOCollapse),
)

export const LazySeoCollapse = (props: SEOCollapseProps) => (
	<RenderOnScroll element={<DynamicSeoCollapse {...props} />} />
)
